
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref, Prop, Watch } from "vue-property-decorator";
    import { VForm } from "@/vForm";
    import PrimaryButton from "@/vue/components/PrimaryButton.vue";
    import HtmlEditor from "@/vue/components/HtmlEditor.vue";
    import { RadioChoiceOptions } from "@/model/pagePartOptions/RadioChoiceOptions";
    import { QuestionTextLayout } from "@/model/Enums";

    interface IChoiceItem {
        description: string;
        isCorrect: boolean;
    }

    @Component({ components: { PrimaryButton, HtmlEditor } })
    export default class RadioChoicePartEdit extends Vue {

        mounted(): void {
            this.choiceItemList = this.choiceItemListFromOptions();
        }

        @Ref("editForm") 
        readonly editForm!: VForm;

        @Prop({ required: true })
        pagePartOptions!: RadioChoiceOptions;

        @Prop({ default: true })
        isQuiz!: boolean;

        // so we can use in template
        questionTextLayout: any = QuestionTextLayout;

        choiceItemList: Array<IChoiceItem>  = [];

        @Watch("choiceItemList", { immediate: false, deep: true })
        onChoiceItemListchanged(): void {
            this.updateOptionsFromChoiceItemList();
        }

        addChoiceItem() {
            this.choiceItemList.push({ description: "", isCorrect: false });
        }

        removeChoiceItem(item: IChoiceItem) {
            const index = this.choiceItemList.indexOf(item);
            if (index > -1) this.choiceItemList.splice(index, 1);
        }

        onIsCorrectClick(item: IChoiceItem) {
            item.isCorrect = true;
            for(const other of this.choiceItemList) {
                if(item !== other) other.isCorrect = false;
            }
        }

        validate(): boolean {
            return this.editForm.validate();
        }

        // whenever model changes
        updateOptionsFromChoiceItemList() {
            const items = this.choiceItemList.filter(i => !!i.description); // ignore any empty ones
            const choices = items.map(i => i.description);
            const correctIndeces = items
                .map((item, index) => ({index:index, isCorrect:item.isCorrect}))
                .filter(a => a.isCorrect)
                .map(b => b.index);
            // Mutating props here? I guess it doesn't complain if they're sub-properties...
            this.pagePartOptions.choices = choices;
            this.pagePartOptions.correctIndex = correctIndeces.length > 0 ? correctIndeces[0] : -1;
        }

        // just on load (mounted) - or we get an infinite loop!
        choiceItemListFromOptions(): Array<IChoiceItem> {
            const list: Array<IChoiceItem> = this.pagePartOptions.choices.map(c => ({ description:c, isCorrect:false }));
            let i = 0;
            for(const item of list) {
                item.isCorrect = this.pagePartOptions.correctIndex === i;
                i++;
            }
            return list;
        }
    }
